import React from 'react';

import SwapVertIcon from '@mui/icons-material/SwapVert';

import BaseActionButton from '../BaseActionButton';
import { IBaseActionButtonProps } from '../interfaces';
import useStyles from './styles';

const SortActionButton = (props: IBaseActionButtonProps) => {
  const { classes } = useStyles();
  return (
    <BaseActionButton {...props}>
      <SwapVertIcon className={classes.icon} />
    </BaseActionButton>
  );
};

export default SortActionButton;
